const ProductTypes = {
  PHYSICAL: 1,
  DIGITAL: 2,
  SERVICE: 3
}

export default ProductTypes
